<!--
  * name: Sns
  * description: [Main] Sns 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="SNS"></bread-crumb>
    <!-- 병헌 : 경로 -->
    <page-title class="mt-14"><strong>SNS</strong> INCELLDERM</page-title>
    <!-- 병헌 : 페이지 제목 -->
    <page-sub-title class="mb-180">
      Share your moment and meet the light of INCELLDERM
    </page-sub-title>
    <instargram :instaList="instaList"/>
    <youtube @open-pop="funcOpenPop" :youtubeData="youtubeData"/>
    <popup :videoId="videoId"/>
  </div>
</template>

<script>
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import PageTitle from '@/components/page/PageTitle.vue';
import PageSubTitle from '@/components/page/PageSubTitle.vue';
import snsApi from '@/apis/sns';
import Instargram from './partial/Instargram.vue'; /* 왜 에러나는지 모르겠음, 화면은 나옴 */
import Youtube from './partial/Youtube.vue'; /* 왜 에러나는지 모르겠음, 화면은 나옴 */
import Popup from './partial/Popup.vue';

const hashtagExtract = /#([^#\s]+)/g;

export default {
  name: 'Sns',
  components: {
    BreadCrumb,
    PageTitle,
    PageSubTitle,
    Instargram,
    Youtube,
    Popup,
  },
  data() {
    return {
      youtubeData: [],
      videoId: '',
      instaList: [],
    };
  },
  methods: {
    init() {
      this.getYoutubeList();
      this.getinstaList();
    },
    funcOpenPop(id) {
      this.videoId = id;
      this.$bvModal.show('popup');
    },
    async getYoutubeList() {
      const youtubeData = await snsApi.getYoutubeList();
      if (youtubeData.error) {
        return;
      }
      this.youtubeData = youtubeData;
    },
    async getinstaList() {
      const result = await snsApi.getinstaList(8);
      if (result.error) {
        return;
      }
      result.forEach((n) => {
        const list = n.caption.match(hashtagExtract);
        // eslint-disable-next-line no-param-reassign
        n.caption = list === null ? '' : list.join('');
      });
      this.instaList = result;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang='scss' scoped>
.modal-dialog{
  margin-right: auto;
  margin-left: auto;
}
/deep/ .text-center.mt-6{
  margin-top: 2.6rem;
}
.list-style03.mt-18{
  margin-top: 4.6rem;
}
/deep/ .list-style03{
  .text-center.mt-6{
    @media (max-width: $mobile-size) {
      margin-top: 1rem;
    }
  }
}
/deep/ .container.list-style03 li.list-style03--play{
  @media (max-width: $mobile-size) {
    margin-bottom: 2.6rem; 
  }
}
</style>
